import Highcharts from 'highcharts';

export default () => {
    //configuració highCharts en català
    Highcharts.setOptions({
        lang: {
            contextButtonTitle: 'Menú contextual del diagrama',
            decimalPoint: ',',
            downloadJPEG: 'Desa com a imatge JPEG',
            downloadPDF: 'Desa com a document PDF',
            downloadPNG: 'Desa com a imatge PNG',
            downloadSVG: 'Desa com a imatge SVG',
            downloadCSV: 'Descarrega en CSV',
            downloadXLS: 'Descarrega en XLS',
            drillUpText: 'Torna a {series.name}',
            loading: 'S\'està carregant...',
            months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre'],
            noData: 'No hi ha dades per mostrar',
            printChart: 'Imprimeix el diagrama',
            resetZoom: 'Restableix el zoom',
            resetZoomTitle: 'Restableix el nivell de zoom 1:1',
            shortMonths: ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Des'],
            thousandsSep: '.',
            weekdays: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte']
        }
    });
};



// WEBPACK FOOTER //
// ./src/configuracioHighCharts.js